import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class StockMovementReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            warehouses: [],
            stockItems: [],
            filters: {
                warehouse_id: '',
                stock_item_id: '',
                start_date: '',
                end_date: '',
                movement_type: ''
            },
            reportData: {
                movements: [],
                totals: {},
                total_movements: 0
            },
            hasGenerated: false
        }
    }

    componentDidMount() {
        this.fetchWarehouses();
        this.fetchStockItems();
        // Set default dates (last 30 days)
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 30);

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                start_date: startDate.toISOString().split('T')[0],
                end_date: endDate.toISOString().split('T')[0]
            }
        }));
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list','get');
            this.setState({warehouses: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    fetchStockItems = async () => {
        try {
            const response = await apiCall('business/stock/item/select-list','get');
            this.setState({stockItems: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    handleFilterChange = (e) => {
        const {name, value} = e.target;
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }));
    }

    generateReport = async () => {
        if(!this.state.filters.start_date || !this.state.filters.end_date) {
            alert('Lütfen tarih aralığı seçiniz!');
            return;
        }

        this.setState({loading: true});
        try {
            const response = await apiCall('business/stock/report/movements','post', JSON.stringify(this.state.filters), {
                'Content-Type': 'application/json'
            });
            if(response.status === 'success') {
                this.setState({
                    reportData: {
                        movements: response.data.movements || [],
                        totals: response.data.totals || {},
                        total_movements: response.data.total_movements || 0
                    },
                    hasGenerated: true
                });
            }
        } catch (e) {
            console.error(e);
            this.setState({hasGenerated: true});
        }
        this.setState({loading: false});
    }

    getMovementTypeLabel = (type) => {
        const types = {
            'purchase': 'Satın Alma',
            'sale': 'Satış',
            'transfer_in': 'Transfer Giriş',
            'transfer_out': 'Transfer Çıkış',
            'adjustment': 'Düzeltme',
            'return': 'İade'
        };
        return types[type] || type;
    }

    getMovementTypeBadge = (type) => {
        const badges = {
            'purchase': 'badge-success',
            'sale': 'badge-danger',
            'transfer_in': 'badge-info',
            'transfer_out': 'badge-warning',
            'adjustment': 'badge-secondary',
            'return': 'badge-primary'
        };
        return badges[type] || 'badge-secondary';
    }

    render() {
        const {loading, warehouses, stockItems, filters, reportData, hasGenerated} = this.state;

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Stok Hareket Raporu"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Raporlar", navigate: "" },
                                { name: "Hareket Raporu", navigate: "" },
                            ]}
                        />

                        {/* Filtreler */}
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Filtreler</h2>
                                    </div>
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Başlangıç Tarihi *</label>
                                                    <input
                                                        type="date"
                                                        name="start_date"
                                                        className="form-control"
                                                        value={filters.start_date}
                                                        onChange={this.handleFilterChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Bitiş Tarihi *</label>
                                                    <input
                                                        type="date"
                                                        name="end_date"
                                                        className="form-control"
                                                        value={filters.end_date}
                                                        onChange={this.handleFilterChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Depo</label>
                                                    <select
                                                        name="warehouse_id"
                                                        className="form-control"
                                                        value={filters.warehouse_id}
                                                        onChange={this.handleFilterChange}
                                                    >
                                                        <option value="">Tüm Depolar</option>
                                                        {warehouses.map(warehouse => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Stok Kalemi</label>
                                                    <select
                                                        name="stock_item_id"
                                                        className="form-control"
                                                        value={filters.stock_item_id}
                                                        onChange={this.handleFilterChange}
                                                    >
                                                        <option value="">Tüm Stok Kalemleri</option>
                                                        {stockItems.map(item => (
                                                            <option key={item.id} value={item.id}>
                                                                {item.name} {item.sku ? `(${item.sku})` : ''}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Hareket Tipi</label>
                                                    <select
                                                        name="movement_type"
                                                        className="form-control"
                                                        value={filters.movement_type}
                                                        onChange={this.handleFilterChange}
                                                    >
                                                        <option value="">Tüm Hareketler</option>
                                                        <option value="purchase">Satın Alma</option>
                                                        <option value="sale">Satış</option>
                                                        <option value="transfer_in">Transfer Giriş</option>
                                                        <option value="transfer_out">Transfer Çıkış</option>
                                                        <option value="adjustment">Düzeltme</option>
                                                        <option value="return">İade</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        onClick={this.generateReport}
                                                        disabled={loading}
                                                        style={{textAlign: "-webkit-center"}}>

                                                        {loading ? <ReactLoading type="spin" width={'20px'} height={'20px'} /> : 'Rapor Oluştur'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* İstatistikler */}
                        {hasGenerated && reportData.movements.length > 0 && reportData.totals && Object.keys(reportData.totals).length > 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Hareket İstatistikleri <small>Toplam {reportData.total_movements} hareket</small></h2>
                                        </div>
                                        <div className="body">
                                            <div className="row">
                                                {Object.entries(reportData.totals).map(([type, stats]) => (
                                                    <div key={type} className="col-lg-2 col-md-4 col-sm-6">
                                                        <div className="card mb-2" style={{boxShadow: '0 1px 3px rgba(0,0,0,0.1)'}}>
                                                            <div className="body text-center p-3">
                                                                <span className={`badge ${this.getMovementTypeBadge(type)} mb-2`}>
                                                                    {this.getMovementTypeLabel(type)}
                                                                </span>
                                                                <h4 className="mb-0">{stats.count}</h4>
                                                                <small className="text-muted">{stats.total_quantity} adet</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Rapor Sonuçları */}
                        {hasGenerated && reportData.movements.length > 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Stok Hareketleri Detayı</h2>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Tarih</th>
                                                            <th>Depo</th>
                                                            <th>Stok Kalemi</th>
                                                            <th className="text-center">Hareket Tipi</th>
                                                            <th className="text-right">Miktar</th>
                                                            <th>Kullanıcı</th>
                                                            <th>Notlar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reportData.movements.map((movement, index) => (
                                                            <tr key={index}>
                                                                <td><small>{new Date(movement.movement_date).toLocaleDateString('tr-TR')} {new Date(movement.movement_date).toLocaleTimeString('tr-TR', {hour: '2-digit', minute: '2-digit'})}</small></td>
                                                                <td>{movement.warehouse?.name || '-'}</td>
                                                                <td><strong>{movement.stock_item?.name || '-'}</strong>{movement.stock_item?.sku && <small className="text-muted d-block">{movement.stock_item.sku}</small>}</td>
                                                                <td className="text-center">
                                                                    <span className={`badge ${this.getMovementTypeBadge(movement.movement_type)}`}>
                                                                        {this.getMovementTypeLabel(movement.movement_type)}
                                                                    </span>
                                                                </td>
                                                                <td className="text-right"><strong>{Math.round(movement.quantity || 0)}</strong></td>
                                                                <td><small>{movement.user?.name || '-'}</small></td>
                                                                <td><small>{movement.notes || '-'}</small></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Veri Yok Uyarısı */}
                        {!loading && hasGenerated && reportData.movements.length === 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="body">
                                            <div className="alert alert-warning text-center mb-0">
                                                <i className="icon-info" style={{fontSize: '48px', display: 'block', marginBottom: '15px'}}></i>
                                                <h4>Veri Bulunamadı</h4>
                                                <p>Seçili filtrelere göre herhangi bir stok hareketi bulunamadı.</p>
                                                <small className="text-muted">Farklı tarih aralığı veya filtreler deneyebilirsiniz.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* İlk Yükleme Mesajı */}
                        {!loading && !hasGenerated && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="body">
                                            <div className="alert alert-info text-center mb-0">
                                                <i className="icon-chart" style={{fontSize: '48px', display: 'block', marginBottom: '15px', color: '#17a2b8'}}></i>
                                                <h4>Rapor Oluşturun</h4>
                                                <p>Stok hareketlerini görüntülemek için filtreleri ayarlayın ve "Rapor Oluştur" butonuna tıklayın.</p>
                                                <small className="text-muted">Varsayılan olarak son 30 günün verileri seçilmiştir.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockMovementReport));




